export default "\n<app-tutor-toolbar></app-tutor-toolbar>\n<main>\n    <app-class-tile [myClass]=\"6\"></app-class-tile>\n</main>"